import { apiGet, apiPost, apiDelete, getCurrentSubTenant } from "./client.js";

const BASE = "/api/v1/test-runs";

const addId = (item) => item ? { ...item, id: item._id || item.runCode } : item;
const addIds = (items) => (items || []).map(addId);

export const listTestRuns = (opts = {}) => {
  const params = new URLSearchParams();
  if (opts.limit) params.set("limit", opts.limit);
  if (opts.status) params.set("status", opts.status);
  const qs = params.toString();
  return apiGet(`${BASE}${qs ? `?${qs}` : ""}`).then((d) => addIds(d.runs));
};
export const getTestRun = (id) => apiGet(`${BASE}/${id}`).then(addId);
export const getActiveRuns = () => apiGet(`${BASE}/active`);
export const runTestCase = (testCaseId, configMode = "draft") => apiPost(BASE, { testCaseId, configMode });
export const runBatch = (testCaseIds, configMode = "draft") => apiPost(BASE, { testCaseIds, configMode });
export const stopTestRun = (runId) => apiPost(`${BASE}/${runId}/stop`, {});
export const clearTestRuns = () => apiDelete(BASE);

export function subscribeLiveStatus(runId, onEvent) {
  const subId = getCurrentSubTenant();
  const es = new EventSource(`/api/v1/live-status/${runId}${subId ? `?subTenantId=${encodeURIComponent(subId)}` : ""}`);
  es.onmessage = (e) => {
    try { onEvent(JSON.parse(e.data)); } catch {}
  };
  es.onerror = () => es.close();
  return () => es.close();
}
